var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAccount = function SvgAccount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13 24.1607C19.1639 24.1607 24.1607 19.1639 24.1607 13C24.1607 6.83611 19.1639 1.83929 13 1.83929C6.83611 1.83929 1.83929 6.83611 1.83929 13C1.83929 19.1639 6.83611 24.1607 13 24.1607ZM13 25.5C19.9036 25.5 25.5 19.9036 25.5 13C25.5 6.09644 19.9036 0.5 13 0.5C6.09644 0.5 0.5 6.09644 0.5 13C0.5 19.9036 6.09644 25.5 13 25.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.4642 9.42852C17.4642 11.8941 15.4655 13.8928 12.9999 13.8928C10.5344 13.8928 8.53564 11.8941 8.53564 9.42852C8.53564 6.96296 10.5344 4.96423 12.9999 4.96423C15.4655 4.96423 17.4642 6.96296 17.4642 9.42852Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.2338 18.3587C19.4812 21.0453 16.4489 22.8211 13.0019 22.8211C9.55343 22.8211 6.52009 21.0438 4.76782 18.3553C6.09235 16.3249 8.14776 14.8147 10.5607 14.1981C11.2928 14.5735 12.1226 14.7854 13.0019 14.7854C13.8806 14.7854 14.7099 14.5738 15.4416 14.1989C17.8546 14.8163 19.9098 16.3274 21.2338 18.3587Z",
    clipRule: "evenodd"
  })));
};
export default SvgAccount;